import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class FieldGoalOutOfBounds extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FieldGoalOutOfBounds;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.setFieldPosition(fragment.fieldPosition);
        gameContext.switchPossession();
        ruleContext.setAwardFirstDown(true);
    }
}
